export default __webpack_public_path__ + "static/1-36-0-new-funnel-viz-dashboard-46f7f91cfc6198abd0f6fb62a946608e.png";